import { AssistantControllerBaseConfig } from '../../base';
import { AssistantContextController } from './interviewContextInterface';
import { AssistantContextViewProps } from './interviewContextProps';

export function createContextController(
    config: AssistantControllerBaseConfig
): AssistantContextController {
    const { kernel } = config;
    return {
        useProps(item, props): AssistantContextViewProps {
            if (props.user) {
                return {
                    value: {
                        principal: {
                            kind: 'user',
                            id: props.user.user,
                            account: props.user.account,
                        },
                        organization: null,
                        token: props.user.token,
                    },
                };
            }

            return {
                value: {
                    principal: {
                        kind: 'session',
                        id: item.session.id,
                    },
                    token: item.session.token,
                    organization: null,
                },
            };
        },
    };
}
